import React, { Component } from 'react'
import { CREATE_WALLET_NAV, RECEIVE_WALLET_NAV, UNLOCK_WALLET_NAV, RESTORE_WALLET_NAV } from '../constants/navigation'

class NotFoundContainer extends Component {
  componentDidMount() {
    const { pathname } = this.props.history.location
    if (pathname) {
      if (pathname.indexOf('index.html') > -1) {
        this.props.history.replace(CREATE_WALLET_NAV)
      } else if (pathname.indexOf('info.html') > -1) {
        this.props.history.replace(RECEIVE_WALLET_NAV)
      } else if (pathname.indexOf('mnemonic.html') > -1) {
        this.props.history.replace(UNLOCK_WALLET_NAV)
      } else if (pathname.indexOf('restore.html') > -1) {
        this.props.history.replace(RESTORE_WALLET_NAV)
      } else {
        this.props.history.replace(CREATE_WALLET_NAV)
      }
    } else {
      this.props.history.replace(CREATE_WALLET_NAV)
    }
  }
  render() {
    return (
      <div className="main-container main-container--flex-column">
        <h1>404</h1>
        <p>page not Found</p>
      </div>
    )
  }
}

export default NotFoundContainer



// WEBPACK FOOTER //
// ./src/containers/NotFoundContainer.js